export default "__VITE_ASSET__JuAgoQ_J__"